var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21045 6.5H18.2104V17.5H7.21045V6.5Z",
    stroke: "#FDC535",
    strokeWidth: 1.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21035 17.5L2.67285 22.0375M18.2104 17.5L22.7478 22.0375L18.2104 17.5ZM18.2104 6.49996L22.7478 1.96246L18.2104 6.49996ZM7.21035 6.49996L2.67285 1.96246L7.21035 6.49996Z",
    stroke: "#FDC535",
    strokeWidth: 1.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9604 1H4.46045C2.94167 1 1.71045 2.23122 1.71045 3.75V20.25C1.71045 21.7688 2.94167 23 4.46045 23H20.9604C22.4792 23 23.7104 21.7688 23.7104 20.25V3.75C23.7104 2.23122 22.4792 1 20.9604 1Z",
    stroke: "#F9A825",
    strokeWidth: 1.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalkon);
export default __webpack_public_path__ + "static/media/balkon.abb9693b68baf6ea297a0afa955fe1ae.svg";
export { ForwardRef as ReactComponent };